import Image from 'next/image';
import { useEffect, useState } from 'react';
import cn from 'classnames';

import BusinesIcon from '../../public/svg/buisnes.svg';
import WebIcon from '../../public/svg/webpage.svg';
import PaintIcon from '../../public/svg/paint.svg';
import ProcessIcon from '../../public/svg/process.svg';

import amaltheare from '../../public/real-estate/amalthea.png';
import phone from '../../public/real-estate/phone.png';
import User from '../../public/real-estate/user.svg';
import Building from '../../public/real-estate/building.svg';
import admin from '../../public/real-estate/admin.png';
import rog from '../../public/real-estate/rog.png';
import styles from './real-estate-amaltheare.module.css';
import {
  Button,
  ComponentsDelivered,
  ContainerFluid,
  Htag,
  HtagVariant,
  List,
  Paragraph,
} from '../../components';

export default function RealEstateAmaltheare() {
  const [mobile, setMobile] = useState<boolean>(false);

  const resizeWindow = () => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };

  useEffect(() => {
    resizeWindow();
    window.addEventListener('resize', resizeWindow);

    return () => {
      window.removeEventListener('resize', resizeWindow);
    };
  }, []);

  return (
    <div id="amaltheare" className={styles.amaltheare}>
      <ContainerFluid className={styles.amaltheare_container}>
        <div className={styles.wrapper}>
          <div className={styles.wrapper_start}>
            <Htag
              tag="h3"
              className={styles.amaltheare_title}
              variant={HtagVariant.h3}
            >
              AMALTHEA
            </Htag>
            <Paragraph className={styles.amaltheare_text}>
              Amalthea carries out apartment renovations and refurbishments. The
              platform allows to manage the properties sales and rental process
              as well as take over the complete handling for the clients.
            </Paragraph>
            <ComponentsDelivered
              className={styles.amaltheare_delivered}
              title="Components delivered:"
              data={[
                {
                  id: 1,
                  text: 'UX/UI design',
                  Icon: PaintIcon,
                },
                {
                  id: 2,
                  text: 'Website',
                  Icon: WebIcon,
                },
                {
                  id: 3,
                  text: 'Business analysis and prototype',
                  Icon: BusinesIcon,
                },
                {
                  id: 4,
                  text: 'Web admin panel',
                  Icon: ProcessIcon,
                },
              ]}
            />
            <div className={styles.phone}>
              {mobile ? (
                <Image
                  alt="Amaltheare site preview"
                  width={1054}
                  height={1348}
                  src={amaltheare}
                />
              ) : (
                <Image
                  alt="Amaltheare mobile site preview"
                  width={413}
                  height={599}
                  src={phone}
                />
              )}
            </div>
            <div
              className={cn(styles.amaltheare_buttonGo, styles.buttonGo_left)}
            >
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://amaltheare.com/"
              >
                <Button appearance="primary">Go to AMALTHEARE Website</Button>
              </a>
            </div>
          </div>
          <div className={styles.wrapper_end}>
            {mobile ? (
              <Image
                alt="Amaltheare mobile site preview"
                width={413}
                height={599}
                src={phone}
              />
            ) : (
              <Image
                alt="Amaltheare site preview"
                width={1054}
                height={1348}
                src={amaltheare}
              />
            )}
            <div
              className={cn(styles.amaltheare_buttonGo, styles.buttonGo_rigth)}
            >
              <a
                rel="noopener noreferrer"
                href="https://amaltheare.com/"
                target="_blank"
              >
                <Button appearance="primary">Go to AMALTHEARE Website</Button>
              </a>
            </div>
          </div>
        </div>
        <div className={styles.flex_wrapper}>
          <div className={styles.flex_wrapperStart}>
            <Image
              alt="Amaltheare admin panel"
              width={1100}
              height={671}
              src={admin}
            />
          </div>
          <div className={styles.flex_wrapperEnd}>
            <List
              className={styles.first_list}
              list={[
                'upload photos',
                'set parameters',
                'add a building plan',
                'write a description',
                'set visibility',
                'choose a type',
              ]}
              Icon={Building}
              title="Create Apartments & Buildings"
            />

            <List
              list={[
                'create and edit users',
                'set permissions',
                'handle incoming messages',
                'change statuses',
              ]}
              Icon={User}
              title="User Administration"
            />
          </div>
        </div>
        <div className={styles.amaltheare_rog}>
          <Image alt="Amaltheare logo" src={rog} width={1271} height={1202} />
        </div>
      </ContainerFluid>
    </div>
  );
}
